/**
 * Constant that holds the keys of hello bars that may be triggered on the site
 *  @type {Object}
 */
export const HELLO_BARS = {
  NEW_ACCOUNT: 'NEW_ACCOUNT',
  PODCAST: 'PODCAST',
}

/**
 * Object that contains active podcast campaign slugs and the display text
 *  @type {Object}
 */
export const podcastCampaignSlugs = {
  viall: 'viall',
  milehigher: 'milehigher',
  fore: 'fore',
  bussin: 'bussin',
  chicks: 'chicks',
  lcb: 'barstool',
  hills: 'hills',
  check: 'blankcheck',
  circletime: 'kelseyk',
  flagrant: 'flagrant',
  giggly: 'giggly',
  tbtb: 'tbtb',
  drunk: 'drunk',
  outandabout: 'about',
  fighter: 'fighter',
  murderwithmyhusband: 'mwmh',
  campea: 'campea',
  toast: 'toast',
  sesh: 'sesh',
  herberts: 'herberts',
  distractable: 'distractable',
  davidsbridal_media_2023: 'dbprom2023',
  unlocked: 'unlocked',
  goodinfluences: 'good',
  pc_pardonmytake: 'pmt',
}
